import React, { useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { NotificationManager } from "react-notifications";
import * as API from "../api/index";
import { useDataView } from "../../contexts/data.view.context";
import { FormField, FormSelectField, FormActions } from "../util/formFields";

const ViewEditTaskSchedule = ({
  curRow,
  handleDetailClose,
  editable,
  onEditClick,
  data,
}) => {
  const { fetchTaskSchedulesFromAllEnv } = useDataView();
  const values = curRow.original;

  const [formData, setFormData] = useState({
    _schedule_id: values._schedule_id,
    schedule_id: values.schedule_id,
    schedule_interval: values.schedule_interval,
    schedule_count: values.schedule_count,
    schedule_cron: values.schedule_cron,
    schedule_state: values.schedule_state,
    schedule_type: values.schedule_type,
    schedule_cmd: values.schedule_cmd,
    schedule_group: values.schedule_group,
    parallel_execute: values.parallel_execute,
  });

  const states = ["Active", "Disable"];
  const types = ["crontab", "synapse"];
  const parallel_execute_options = ["Y", "N"];

  function handleSubmit(event) {
    event.preventDefault();
    const schedule_id = formData.schedule_id;
    const origScheduleId = values.schedule_id;
    let checkConnectionIDExists = null;

    if (origScheduleId === schedule_id) {
      // connection id is not edited
    } else {
      checkConnectionIDExists = data.find(
        (connection) => connection.schedule_id === schedule_id
      );
    }

    if (checkConnectionIDExists) {
      NotificationManager.error("", "Schedule ID exists!", 10000);
    } else {
      const payload = [
        {
          _schedule_id: values._schedule_id,
          schedule_id: formData.schedule_id,
          schedule_interval: formData.schedule_interval,
          schedule_count: formData.schedule_count,
          schedule_cron: formData.schedule_cron,
          schedule_state: formData.schedule_state,
          schedule_type: formData.schedule_type,
          schedule_cmd: formData.schedule_cmd,
          schedule_group: formData.schedule_group,
          parallel_execute: formData.parallel_execute,
        },
      ];

      const resourcePath = "integrations/cfg/schedules";

      API.UpdateRecord(resourcePath, payload).then((response) => {
        if (response.code === 200) {
          fetchTaskSchedulesFromAllEnv();
          NotificationManager.success(
            "Record Updated",
            "Query Schedule",
            10000
          );
        } else {
          NotificationManager.error(response.message, "Failed!", 10000);
        }
      });
    }
  }

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  return (
    <Box>
      <Stack spacing={0}>
        <FormField required id="schedule_id" name="schedule_id" label="ID" disabled value={formData.schedule_id} onChange={handleChange} />
        <FormField required id="schedule_cron" name="schedule_cron" label="Cron" disabled={!editable} value={formData.schedule_cron} onChange={handleChange} />
        <FormSelectField id="schedule_state" name="schedule_state" label="State" disabled={!editable} value={formData.schedule_state} onChange={handleChange} items={states} />
        <FormSelectField id="schedule_type" name="schedule_type" label="Type" disabled={!editable} value={formData.schedule_type} onChange={handleChange} items={types} />
        <FormField required id="schedule_cmd" name="schedule_cmd" label="Command" disabled={!editable} value={formData.schedule_cmd} onChange={handleChange} />
        <FormField required id="schedule_group" name="schedule_group" label="Group" disabled={!editable} value={formData.schedule_group} onChange={handleChange} />
        <FormSelectField id="parallel_execute" name="parallel_execute" label="Parallel Execute" disabled={!editable} value={formData.parallel_execute} onChange={handleChange} items={parallel_execute_options} />
      </Stack>

      <FormActions>
        <Button variant="outlined" disabled={editable} onClick={onEditClick}>
          Edit
        </Button>
        <Button variant="contained" color="primary" disabled={!editable} onClick={handleSubmit}>
          Save
        </Button>
        <Button variant="text" color="inherit" onClick={handleDetailClose}>
          Close
        </Button>
      </FormActions>
    </Box>
  );
};

export default ViewEditTaskSchedule;
